import { render, staticRenderFns } from "./DashboardOrder.vue?vue&type=template&id=f9a91750&"
import script from "./DashboardOrder.vue?vue&type=script&lang=js&"
export * from "./DashboardOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/proyectos/rosalinda-store/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle,VDivider})
